export var IDENTITY_STATE;
(function (IDENTITY_STATE) {
    IDENTITY_STATE["cache"] = "cache";
    IDENTITY_STATE["fresh"] = "fresh";
})(IDENTITY_STATE || (IDENTITY_STATE = {}));
export var VALUES_TYPES;
(function (VALUES_TYPES) {
    VALUES_TYPES["string"] = "string";
    VALUES_TYPES["integer"] = "integer";
    VALUES_TYPES["boolean"] = "boolean";
    VALUES_TYPES["object"] = "object";
    VALUES_TYPES["array"] = "array";
    VALUES_TYPES["number"] = "number";
    VALUES_TYPES["hashString"] = "hashString";
    VALUES_TYPES["addressObject"] = "addressObject";
    VALUES_TYPES["phone"] = "phone";
    VALUES_TYPES["email"] = "email";
    VALUES_TYPES["secid"] = "secid";
})(VALUES_TYPES || (VALUES_TYPES = {}));
export var IDENTITIES_KEYS;
(function (IDENTITIES_KEYS) {
    IDENTITIES_KEYS["sid"] = "sid";
    IDENTITIES_KEYS["login"] = "login";
    IDENTITIES_KEYS["consent"] = "consent";
    IDENTITIES_KEYS["udid"] = "udid";
    IDENTITIES_KEYS["eid"] = "eid";
    IDENTITIES_KEYS["id5"] = "id5";
    IDENTITIES_KEYS["tid"] = "tid";
    IDENTITIES_KEYS["aid"] = "aid";
    IDENTITIES_KEYS["secid"] = "secid";
})(IDENTITIES_KEYS || (IDENTITIES_KEYS = {}));
export var IDENTITIES_KEYS_SPECIAL;
(function (IDENTITIES_KEYS_SPECIAL) {
    IDENTITIES_KEYS_SPECIAL["rusId"] = "rusId";
    IDENTITIES_KEYS_SPECIAL["premium"] = "premium";
    IDENTITIES_KEYS_SPECIAL["sbr"] = "sbr";
    IDENTITIES_KEYS_SPECIAL["said"] = "said";
    IDENTITIES_KEYS_SPECIAL["state"] = "state";
    IDENTITIES_KEYS_SPECIAL["pid"] = "pid";
    IDENTITIES_KEYS_SPECIAL["login"] = "login";
})(IDENTITIES_KEYS_SPECIAL || (IDENTITIES_KEYS_SPECIAL = {}));
// input data types (can differ from output data types -> updateIdentities({consent: "consentString"}) -> getIdentity("consent") -> consent object)
export var IDENTITIES_VALUES_TYPES;
(function (IDENTITIES_VALUES_TYPES) {
    IDENTITIES_VALUES_TYPES["sid"] = "string";
    IDENTITIES_VALUES_TYPES["login"] = "object";
    IDENTITIES_VALUES_TYPES["consent"] = "object";
    IDENTITIES_VALUES_TYPES["udid"] = "string";
    IDENTITIES_VALUES_TYPES["pid"] = "string";
    IDENTITIES_VALUES_TYPES["eid"] = "email";
    IDENTITIES_VALUES_TYPES["rusId"] = "integer";
    IDENTITIES_VALUES_TYPES["premium"] = "boolean";
    IDENTITIES_VALUES_TYPES["sbr"] = "boolean";
    IDENTITIES_VALUES_TYPES["said"] = "string";
    IDENTITIES_VALUES_TYPES["state"] = "string";
    IDENTITIES_VALUES_TYPES["id5"] = "string";
    IDENTITIES_VALUES_TYPES["tid"] = "phone";
    IDENTITIES_VALUES_TYPES["aid"] = "addressObject";
    IDENTITIES_VALUES_TYPES["secid"] = "secid";
})(IDENTITIES_VALUES_TYPES || (IDENTITIES_VALUES_TYPES = {}));
export var ADDRESS;
(function (ADDRESS) {
    ADDRESS["state"] = "a1";
    ADDRESS["city"] = "a2";
    ADDRESS["street"] = "a3";
    ADDRESS["houseNumber"] = "a4";
    ADDRESS["postalCode"] = "a5";
})(ADDRESS || (ADDRESS = {}));
export var PHONE;
(function (PHONE) {
    PHONE["areaCode"] = "t1";
    PHONE["number"] = "t2";
})(PHONE || (PHONE = {}));
export var DOT_CONFIG_PROPERTIES;
(function (DOT_CONFIG_PROPERTIES) {
    DOT_CONFIG_PROPERTIES["badge"] = "badge";
})(DOT_CONFIG_PROPERTIES || (DOT_CONFIG_PROPERTIES = {}));
